const getWindow = () => (typeof window !== 'undefined' ? window : global.window);

const logToNewRelic = (callerComponent, message, error = null) => {
    const windowObj = getWindow();
    windowObj?.newrelic?.addPageAction('ActivEngageError', {
        component: 'getChatSessionToken',
        callerComponent,
        message,
        ...(error && { error: error.message || 'Unknown error' }),
        url: windowObj?.location?.href || '',
    });
};

/**
 * Retrieves the chat session token from ActivEngage if available.
 *
 * Uses ActivEngage.tracking.createSessionToken() to generate a session identifier.
 *
 * @param {string} callerComponent - The name of the component calling this function (for error tracking)
 * @returns {Promise<string|null>} A promise that resolves to the chat session token
 *                                 if ActivEngage is available, otherwise null
 */
const getChatSessionToken = (callerComponent = 'unknown') =>
    new Promise((resolve) => {
        try {
            const windowObj = getWindow();
            const createSessionToken = windowObj?.ActivEngage?.tracking?.createSessionToken;

            if (typeof createSessionToken !== 'function') {
                resolve(null);
                return;
            }

            createSessionToken()
                .done(resolve)
                .fail(() => {
                    logToNewRelic(callerComponent, 'Failed to create Active Engage session token');
                    resolve(null);
                });
        } catch (error) {
            logToNewRelic(callerComponent, 'Error creating Active Engage session token', error);
            resolve(null);
        }
    });

export default getChatSessionToken;
